import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ThreeDotsLoader } from "@atoms"
import { Header, Subtitle } from "modules/layout/auth"
import useQueryParams from "utils/useQueryParams"
import { useConfirmEmailChange } from "./queries"
import { ErrorIcon } from "../__components/icons"
import authStyles from "../styles.module.scss"
import styles from "./styles.module.scss"
import { Button, Card } from "antd"

const EmailChangeConfirm = () => {
  const { t } = useTranslation()
  const params = useQueryParams()

  const confirmEmailChange = useConfirmEmailChange({
    user :params.user as string,
    email :params.email as string,
    signature :params.signature as string,
    expires :params.expires as string,
  })


  return (
    <Card className={authStyles.card}>
      <Header>{t("profile.emails.confirmTitle")}</Header>

      {confirmEmailChange.isLoading && (
        <>
          <div className={authStyles.loader}>
            <ThreeDotsLoader />
          </div>
          <Subtitle>{t("auth.verifying")}</Subtitle>
        </>
      )}

      {confirmEmailChange.isSuccess && (
        <>
          <div className={styles.statusIcon}>
            <svg width="36" height="37" viewBox="0 0 36 37" aria-hidden>
              <path
                d="M18.0007 0.583008C8.11065 0.583008 0.0839844 8.60968 0.0839844 18.4997C0.0839844 28.3897 8.11065 36.4163 18.0007 36.4163C27.8907 36.4163 35.9173 28.3897 35.9173 18.4997C35.9173 8.60968 27.8907 0.583008 18.0007 0.583008ZM14.4173 27.458L5.45898 18.4997L7.98523 15.9734L14.4173 22.3876L28.0161 8.78884L30.5423 11.333L14.4173 27.458Z"
                fill="var(--color-accent1)"
              />
            </svg>
          </div>
          <Subtitle>{t("profile.emails.confirmSuccess")}</Subtitle>
          <Link to="/auth/sign-in">
            <Button size="large" type="primary" block>
              {t("profile.emails.backToLogin")}
            </Button>
          </Link>
        </>
      )}

      {!confirmEmailChange.isLoading && !confirmEmailChange.isSuccess && (
        <>
          <div className={styles.errorIcon}>
            <ErrorIcon />
          </div>
          <Subtitle>{t("profile.emails.confirmError")}</Subtitle>
          <Link to="/auth/sign-in">
            <Button size="large" type="primary" block>
              {t("profile.emails.backToLogin")}
            </Button>
          </Link>
        </>
      )}
    </Card>
  )
}

export default EmailChangeConfirm
